import { BaseService } from '@services/BaseService'

const resource = 'hr/diagnostic'

class DiagnosticService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const diagnosticService = new DiagnosticService()
